import { Box, styled } from '@material-ui/core'

const Flexbox = styled(Box)({
  display: 'flex'
})

export default Flexbox
